import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import GenerationsSelect from "../../select/generation";
import { deepEqual } from "../../../utils/object";

class Name extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta?.default ?? {},
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    
    getData = () => {
        return this.state.data;
    }
        
    componentDidUpdate(oldProps) {
        // Update state when props.data changes
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default ?? {};
        if (deepEqual(this.state.data, newData)) return;
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });   
    }

    onChange = (e) => {
        const newData = {
            ...this.state.data,
            [e.target.name]: e.target.value
        };

        if (newData === this.state.data) return;
        
        this.setState({
            data: newData
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    onGenerationChange = (e) => {
        this.onChange({ target: { name: "generation", value: e.value } });
    }

    render() {
        return (<>
            {this.state.label ?
                <Row className="g-3">
                    <Col lg="12">
                        <h2 className="small-title">{this.state.label}</h2>
                    </Col>
                </Row>
                : ``}
            <Row className="g-3">
                <Col lg="4">
                    <div className="mb-3 top-label">
                        <Form.Control type="text" name="first" value={this.state.data?.first || ""} onChange={this.onChange} readOnly={this.state.locked} />
                        <Form.Label>FIRST NAME</Form.Label>
                    </div>
                </Col>
                <Col lg="2">
                    <div className="mb-3 top-label">
                        <Form.Control type="text" name="middle" value={this.state.data?.middle || ""} onChange={this.onChange} readOnly={this.state.locked} />
                        <Form.Label>MIDDLE NAME</Form.Label>
                    </div>
                </Col>
                <Col lg="4">
                    <div className="mb-3 top-label">
                        <Form.Control type="text" name="last" value={this.state.data?.last || ""} onChange={this.onChange} readOnly={this.state.locked} />
                        <Form.Label>LAST NAME</Form.Label>
                    </div>
                </Col>
                <Col lg="2">
                    <div className="mb-3 top-label">
                        {(this.state.locked) ?
                            <Form.Control type="text" name="generation" value={this.state.data?.generation || ""} readOnly={this.state.locked} />
                            :
                            <GenerationsSelect value={this.state.data?.generation || ""} onChange={this.onGenerationChange} placeholder="" name="generation" />
                        }
                        <Form.Label>SUFFIX</Form.Label>
                    </div>
                </Col>
            </Row>
        </>)
    }
}

export default Name;